import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@tanstack/react-query';
import useEventTicketQueries from '@dashboard/hooks/queries/useEventTicketQueries';
import { pageTicketTypesKey } from '@/dashboard/lib/queryKeys';
import TicketTypeMultiSelectList from './TicketTypeMultiSelect/TicketTypeMultiSelectList';

const SelectedTicketsDisplay = ({ pageId, selectedTicketIds }) => {
  const { getTicketTypesForPage } = useEventTicketQueries();

  const { data: ticketTypesData } = useQuery({
    queryKey: pageTicketTypesKey(pageId),
    queryFn: () => getTicketTypesForPage(pageId),
    enabled: !!pageId && selectedTicketIds.length > 0,
  });

  if (selectedTicketIds.length === 0 || !ticketTypesData) {
    return null;
  }

  const selectedTickets = ticketTypesData.filter(ticket => selectedTicketIds.includes(ticket._id));
  const selectedTicketsMap = new Map(selectedTickets.map(ticket => [ticket._id, ticket]));

  return (
    <div className="mt-2">
      <TicketTypeMultiSelectList
        ticketTypes={selectedTickets}
        selectedTicketTypes={selectedTicketsMap}
        interactive={false}
        showCheckboxes={false}
      />
    </div>
  );
};

SelectedTicketsDisplay.propTypes = {
  pageId: PropTypes.string.isRequired,
  selectedTicketIds: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default SelectedTicketsDisplay;
